import React from 'react';
import { Content, Flex, Text, Button, Pane } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import { GlobalState } from '@leverege/ui-redux';
import S from '../../PairForm.css';
import Detail from '../Detail';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function LocatorPaired(props) {
  const {
    areaClassName,
    footerClassName,
    onClose,
    titleVariant,
    titleIcon,
    onOkay,
    selectedObject
  } = props;
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx(Content.Header, {
      children: /*#__PURE__*/_jsx(TitleBar, {
        variant: titleVariant,
        title: "Pair Locator to Vehicle",
        icon: titleIcon,
        children: /*#__PURE__*/_jsx(Button, {
          variant: "pairClose",
          className: S.close,
          onClick: onClose
        })
      })
    }), /*#__PURE__*/_jsx(Content.Area, {
      style: {
        maxHeight: '75vh'
      },
      className: areaClassName,
      children: /*#__PURE__*/_jsxs(Flex, {
        variant: "colL",
        children: [/*#__PURE__*/_jsx("img", {
          className: S.locatorError,
          src: "https://recovr-ui-assets.storage.googleapis.com/locator-error.png",
          alt: "Locator warning",
          height: 136,
          width: 136
        }), /*#__PURE__*/_jsx(Text, {
          variant: "formTitle",
          children: "Locator Already Paired"
        }), /*#__PURE__*/_jsx(Text, {
          children: "This locator is already paired to another vehicle device. You must first unpair the existing vehicle from the locator before you can pair this vehicle to it."
        }), /*#__PURE__*/_jsx(Pane, {
          variant: "dashboardCard",
          children: /*#__PURE__*/_jsxs(Pane, {
            layout: "flex:col",
            variant: "dataCard",
            children: [/*#__PURE__*/_jsx(Detail, {
              className: S.detailPair,
              label: "Existing Vehicle ID",
              value: GlobalState.get()?.models?.lookup?.[selectedObject?.locator?.data?.vehicle?.id]?.data?.vin || 'Unknown'
            }), /*#__PURE__*/_jsx(Detail, {
              className: S.detailPair,
              label: "Installation Location",
              value: selectedObject?.locator?.data?.installLocation || 'Unknown'
            })]
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(Content.Footer, {
      className: footerClassName,
      layout: "flex:rowMEnd",
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: onClose,
        variant: "secondary",
        children: "Cancel"
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "button.pairing.offlineReturnToForm",
        variant: "primary",
        onClick: onOkay,
        children: "Override & Pair"
      })]
    })]
  });
}